import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

import * as Yup from 'yup';

import { isNull, isArray, concat, isEmpty, get } from 'lodash';
import moment from 'moment';

import api from '~/services/api';
import { t, parseDateString } from '~/helpers';
import { Report } from '~/components';
import { RadioGroup, Input } from '~/components/Form';

import { GFO, GFU, GFE, GFE_CONSULTA, ADM } from '~/constants/perfil';


import DateTime from './componentes/DateTime';

function Relinstrumentomedicaoresultado() {
  const [open, setOpen] = useState(true);

  const {
    glousuariotipo,
    glousuariologin,
    glousuarioorgacodigo,
    glousuarioorganome,
  } = useSelector((state) => state.user.profile);


  const [cosiimrdiaini, setCosiimrdiaini] = useState(15);
  const [cosiimrdiafim, setCosiimrdiafim] = useState(14);

  const [filtro, setFiltro] = useState([]);
  const [selecionaranomes, setSelecionaranomes] = useState({});

  const [periodoconsulta, setPeriodoconsulta] = useState('');
  const [periodoconsultafim, setPeriodoconsultafim] = useState('');
  const [periodoconsultaini, setPeriodoconsultaini] = useState('');

  const [datahoranovocontrolefaturamento, setDatahoranovocontrolefaturamento] = useState(null);
  const [datahoranovocontrolefaturamentofim, setDatahoranovocontrolefaturamentofim] = useState(null);

  const [pickerDataFim, setPickerDataFim] = useState(null);

  async function getConfigSistema() {
    try {
      //setIsLoading(true);
      const response = await api.get(`/configsistema`);

      const statusRetorno = get(
        response,
        'data.cosi_imr_dia_fim',
        ''
      );

      const datahoranovocontrolefaturamentolocal = get(
        response,
        'data.cosi_datahora_novo_controle_faturamento',
        ''
      );

      const cosiimrdiainilocal = get(
        response,
        'data.cosi_imr_dia_ini',
        '15'
      );

      const cosiimrdiafimlocal = get(
        response,
        'data.cosi_imr_dia_fim',
        '14'
      );




      //await setIsLoading(false);
      if (String(statusRetorno) === '') {
        toast.error('Não foi possível fazer a consulta!');
        return;
      }
      setCosiimrdiaini(cosiimrdiainilocal);
      setCosiimrdiafim(cosiimrdiafimlocal);
      setDatahoranovocontrolefaturamento(datahoranovocontrolefaturamentolocal);


      const currentDate = new Date();
      const currentDateMoment = moment();

      let formattedDate = "";

      if (glousuariotipo === ADM) {
        formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-01 00:00:00`;
      } else {
        formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${cosiimrdiafimlocal} 00:00:00`;
      }

      // let formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${cosiimrdiafimlocal} 00:00:00`;

      // let formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${cosiimrdiafimlocal} 00:00:00`;
      let specificDate = moment(formattedDate);
      // const isAfter = currentDateMoment.isAfter(specificDate);  // Se a data atual for posterior
      const isBefore = currentDateMoment.isBefore(specificDate);  // Se a data atual for anterior
      // const isSame = currentDateMoment.isSame(specificDate, 'day');

      if (isBefore) {
        formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth()}-01 00:00:00`;
        specificDate = moment(formattedDate);
      }

      setDatahoranovocontrolefaturamentofim(specificDate);
      setPickerDataFim(specificDate);



    } catch (err) {
      setCosiimrdiaini(15);
      setCosiimrdiafim(14);
      toast.error(` ${err} `);
    }
  }


  const onSerializeData = useCallback(
    (data) => {
      console.log(data);


      const formattedDateendDate = pickerDataFim;

      return {
        ...data,
        periodo: periodoconsulta,
        periodoconsultaini: periodoconsultaini,
        periodoconsultafim: periodoconsultafim
      };
    },
    [filtro, periodoconsulta, periodoconsultaini, periodoconsultafim, pickerDataFim]
  );

  const handleValidate = useCallback(
    async (data) => {
      try {

        //toast.error('Erro, parâmetro já existe na tabela !')
        //return;

        const schema = Yup.object().shape({
          periodo: Yup.string()
            .nullable()
            .required(t('s.geral.validacao.campoobrigatorio')),
        });

        await schema.validate({
          ...data,
          periodo: periodoconsulta
        }, {
          abortEarly: false,
        });

      } catch (err) {
        const form = {};

        if (err instanceof Yup.ValidationError) {
          err.inner.forEach((error) => {
            form[error.path] = error.message.replace(`${error.path} `, '');
          });

          throw { form };
        }
      }
    },
    [filtro, periodoconsulta]
  );


  const handleChangeDatapickerDataFim = React.useCallback((value) => {
    setPickerDataFim(value);
  }, []);

  useEffect(() => {
    if (!isEmpty(pickerDataFim)) {

      const dataselecionada = pickerDataFim.format('MM/YYYY');

      // console.log(dataselecionada);

      let month = parseInt(dataselecionada.split('/')[0], 10);
      let year = parseInt(dataselecionada.split('/')[1], 10);
      if (month === 1) {
        month = 12;
        year = year - 1;
      } else {
        month = month - 1;
      }
      const formattedMonth = month.toString().padStart(2, '0');
      const formattedyear = year.toString().padStart(4, '0');
      // console.log(`${cosiimrdiaini}/${formattedMonth}/${formattedyear} 00:00:00`);
      // console.log(`${cosiimrdiafim}/${selecionaranomes} 23:59:59`);
      setPeriodoconsultaini(`${cosiimrdiaini}/${formattedMonth}/${formattedyear} 00:00:00`);
      setPeriodoconsultafim(`${cosiimrdiafim}/${dataselecionada} 23:59:59`);
      const periodo = `${cosiimrdiaini}/${formattedMonth}/${formattedyear} - ${cosiimrdiafim}/${dataselecionada}`;
      setPeriodoconsulta(periodo)
    }
    // if (!isEmpty(selecionaranomes)) {
    //   let month = parseInt(selecionaranomes.split('/')[0], 10);
    //   let year = parseInt(selecionaranomes.split('/')[1], 10);
    //   if (month === 1) {
    //     month = 12;
    //     year = year - 1;
    //   } else {
    //     month = month - 1;
    //   }
    //   const formattedMonth = month.toString().padStart(2, '0');
    //   const formattedyear = year.toString().padStart(4, '0');
    //   // console.log(`${cosiimrdiaini}/${formattedMonth}/${formattedyear} 00:00:00`);
    //   // console.log(`${cosiimrdiafim}/${selecionaranomes} 23:59:59`);
    //   setPeriodoconsultaini(`${cosiimrdiaini}/${formattedMonth}/${formattedyear} 00:00:00`);
    //   setPeriodoconsultafim(`${cosiimrdiafim}/${selecionaranomes} 23:59:59`);
    //   const periodo = `${cosiimrdiaini}/${formattedMonth}/${formattedyear} - ${cosiimrdiafim}/${selecionaranomes}`;
    //   setPeriodoconsulta(periodo)
    // }
  }, [selecionaranomes, cosiimrdiaini, cosiimrdiafim, pickerDataFim]);



  // const [periodoconsulta, setPeriodoconsulta] = useState('');
  // const [periodoconsultafim, setPeriodoconsultafim] = useState('');
  // const [periodoconsultaini, setPeriodoconsultaini] = useState('');


  useEffect(() => {
    getConfigSistema();
  }, []);

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title="Relatório instrumento de medição de resultado"
      relatorio="rel_instrumento_medicao_resultado"
      // serialize={(param) => onSerializeData(param)}
      serialize={onSerializeData}
      validate={handleValidate}
      initials={{
        tipo: 'pdf',
      }}
    >

      <DateTime
        time
        label="Selecione o mês e ano"
        name="selecionaranomes"
        disableFuture={true}
        invalidDateMessage={''}
        minDateMessage={''}
        maxDateMessage={''}
        minDate={isNull(datahoranovocontrolefaturamento) ? '' : datahoranovocontrolefaturamento}

        maxDate={isNull(datahoranovocontrolefaturamentofim) ? '' : datahoranovocontrolefaturamentofim}

        value={pickerDataFim}

        onChange={handleChangeDatapickerDataFim}

        getValue={(value) => {
          setSelecionaranomes(value)

        }
        }
        serialize={(value) =>
          value
            .set({ hour: 0, minute: 0, seconds: 0 })
            .format('MM/YYYY')
        }
      />


      <Input
        name="periodo"
        label="Período"
        value={periodoconsulta}
        disabled
      />

      <RadioGroup
        row
        name="tipo"
        label="Formato"
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'xls' },
        ]}
      />
    </Report>
  );
}

export default Relinstrumentomedicaoresultado;
